module.exports = __webpack_public_path__ + "img/icon10.4281c7e.png";